import { Action, createReducer, on } from '@ngrx/store';
import * as LocationActions from './location.actions';
import { Location } from '@fantaz/shared/data-access/models';

export const LOCATION_FEATURE_KEY = 'location';

export interface LocationState {
  location: Location | null; // which Location record has been selected
  loading: boolean;
  loaded: boolean; // has the Location list been loaded
  blockedToCash: boolean; // has the Location list been loaded
  verifyCashPlayStatus: boolean; // has the Location list been loaded
  userAllowToUseFallbackLocation: boolean; // forced by user
  error?: any | null; // last known error (if any)
}

export interface LocationPartialState {
  readonly [LOCATION_FEATURE_KEY]: LocationState;
}

export const initialState: LocationState = {
  loaded: false,
  loading: false,
  blockedToCash: true,
  verifyCashPlayStatus: false,
  userAllowToUseFallbackLocation: false,
  location: null,
  error: null,
};

const reducer = createReducer(
  initialState,
  on(LocationActions.loadLocation, (state) => ({
    ...state,
    loaded: false,
    error: null,
    loading: true,
  })),
  on(LocationActions.verifyCashPlayStatus, (state) => ({
    ...state,
    loaded: false,
    error: null,
    loading: true,
  })),
  on(
    LocationActions.loadLocationSuccess,
    (state, { location, userAllowToUseFallbackLocation }) => ({
      ...state,
      location,
      userAllowToUseFallbackLocation,
      loaded: true,
      loading: false,
    }),
  ),
  on(LocationActions.loadLocationFailure, (state, { error }) => ({
    ...state,
    error: { code: error.code, message: error.message },
    loaded: false,
    loading: false,
  })),
  on(LocationActions.verifyCashPlayStatusSuccess, (state, { blocked }) => ({
    ...state,
    blockedToCash: blocked,
    verifyCashPlayStatus: true,
    loaded: true,
    loading: false,
  })),
  on(LocationActions.verifyCashPlayStatusFailure, (state, { error }) => ({
    ...state,
    error: { code: error.code, message: error.message },
    loaded: false,
    loading: false,
  })),
);

export function locationReducer(
  state: LocationState | undefined,
  action: Action,
) {
  return reducer(state, action);
}
